import * as Sentry from '@sentry/angular';

import { environment } from '@env';

import { ignoreErrors } from './ignore-errrors';
import { denyUrls } from './deny-urls';

export function initSentry(): void {
  Sentry.init({
    dsn: environment.sentryDsn,
    release: environment.version,
    environment: 'prod',
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      Sentry.browserTracingIntegration(), Sentry.replayIntegration()
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    ignoreErrors,
    denyUrls,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}
